// MD5 (RFC 1321) — returns 32-char lowercase hex string
const S = [7,12,17,22,7,12,17,22,7,12,17,22,7,12,17,22,
           5, 9,14,20,5, 9,14,20,5, 9,14,20,5, 9,14,20,
           4,11,16,23,4,11,16,23,4,11,16,23,4,11,16,23,
           6,10,15,21,6,10,15,21,6,10,15,21,6,10,15,21];

/* eslint-disable no-mixed-operators */
const K = [
  0xd76aa478,0xe8c7b756,0x242070db,0xc1bdceee,0xf57c0faf,0x4787c62a,0xa8304613,0xfd469501,
  0x698098d8,0x8b44f7af,0xffff5bb1,0x895cd7be,0x6b901122,0xfd987193,0xa679438e,0x49b40821,
  0xf61e2562,0xc040b340,0x265e5a51,0xe9b6c7aa,0xd62f105d,0x02441453,0xd8a1e681,0xe7d3fbc8,
  0x21e1cde6,0xc33707d6,0xf4d50d87,0x455a14ed,0xa9e3e905,0xfcefa3f8,0x676f02d9,0x8d2a4c8a,
  0xfffa3942,0x8771f681,0x6d9d6122,0xfde5380c,0xa4beea44,0x4bdecfa9,0xf6bb4b60,0xbebfbc70,
  0x289b7ec6,0xeaa127fa,0xd4ef3085,0x04881d05,0xd9d4d039,0xe6db99e5,0x1fa27cf8,0xc4ac5665,
  0xf4292244,0x432aff97,0xab9423a7,0xfc93a039,0x655b59c3,0x8f0ccc92,0xffeff47d,0x85845dd1,
  0x6fa87e4f,0xfe2ce6e0,0xa3014314,0x4e0811a1,0xf7537e82,0xbd3af235,0x2ad7d2bb,0xeb86d391,
];
/* eslint-enable no-mixed-operators */

export function md5hex(str) {
  const msg = unescape(encodeURIComponent(str));
  const n = msg.length;
  const numWords = ((n + 72) >> 6) << 4;
  const w = new Array(numWords).fill(0);
  for (let i = 0; i < n; i++) w[i >> 2] |= (msg.charCodeAt(i) & 0xff) << ((i & 3) << 3);
  w[n >> 2] |= 0x80 << ((n & 3) << 3);
  w[numWords - 2] = (n << 3) >>> 0;
  w[numWords - 1] = n >>> 29;

  let a0 = 0x67452301, b0 = 0xefcdab89, c0 = 0x98badcfe, d0 = 0x10325476;
  for (let blk = 0; blk < numWords; blk += 16) {
    let A = a0, B = b0, C = c0, D = d0;
    /* eslint-disable no-mixed-operators */
    for (let i = 0; i < 64; i++) {
      let F, g;
      if (i < 16)      { F = (B & C) | (~B & D); g = i; }
      else if (i < 32) { F = (D & B) | (~D & C); g = (5 * i + 1) & 15; }
      else if (i < 48) { F = B ^ C ^ D;           g = (3 * i + 5) & 15; }
      else             { F = C ^ (B | ~D);         g = (7 * i) & 15; }
      const tmp = D; D = C; C = B;
      const T = (A + F + K[i] + w[blk + g]) | 0;
      B = (B + ((T << S[i]) | (T >>> (32 - S[i])))) | 0;
      A = tmp;
    }
    /* eslint-enable no-mixed-operators */
    a0 = (a0 + A) | 0; b0 = (b0 + B) | 0; c0 = (c0 + C) | 0; d0 = (d0 + D) | 0;
  }

  return [a0, b0, c0, d0].map(h => {
    let hex = '';
    for (let i = 0; i < 4; i++) hex += ((h >>> (i * 8)) & 0xff).toString(16).padStart(2, '0');
    return hex;
  }).join('');
}
